import React from 'react'
import { Button, Typography, withStyles, withWidth } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'

export const ARTICLE_RELIABILITY = 'ARTICLE_RELIABILITY'

const styles = theme => ({
  root: {
    padding: 50,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

  },
  pointsBackground: {
    margin: '0 auto',
    flex: 1
  },
  pyramidContainer: {
    display: 'flex',
    maxWidth: 1260
  },
  pyramidImage: {
    width: '50%',
    maxWidth: 630,
    minHeight: 1200

  },
  pyramidSvgContainer: {
    height: 170,
  },
  pyramidChoices: {
    width: '50%',
    maxWidth: 630
  },
  sortableList: {},

  sortableItem: {
    margin: '10px',
    textAlign: 'justify',
    paddingLeft: 5,
    borderLeft: 'black solid',
    minHeight: 160
  },
  SortableItemHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    // margin: 5,
    padding: 3,
    textTransform: 'uppercase'
  },
  svg: {
    width: '100%',
    display: 'block',
    backgroundColor: '#EDEDED',
  },
  polygon: {
    fill: theme.palette.common.white,
    // fill: 'grey',
    stroke: theme.palette.divider,
    strokeWidth: 1,
  },
  svgText: {
    backgroundColor: '#F90000',
    color: 'white'
  },
  pyramidHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    display: 'block',
    position: 'relative',
    padding: 5,
    textAlign: 'center'
  },
  symbolsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    // width: '50%'
  },
  symbolCard: {
    borderStyle: 'solid',
    borderWidth: 26,
    borderColor: 'brown',
    width: 300,
    height: 450,
    margin: 5,
    alignContent: 'center',
    position: 'relative',
  },
  symbolCardImage: {
    width: '100%',
    top: '50%',
    transform: 'translate(0%,-50%)',
    position: 'absolute',
    // margin: '0 5%'
    padding: '5%'
  },
  symbolCardText: {
    textAlign: 'center',
    padding: 10,
    top: '50%',
    transform: 'translate(0%,-50%)',
    position: 'absolute',
  },
  draggableText: {
    margin: 3
  },
  dropTarget: {
    // backgroundColor: 'green',
  },
  barometerAgree: {},
  barometerAgreeQuestion: {
    width: '100%'
  },
  barometerGauge: {
    maxWidth: 600,
    margin: '0 auto',
    position: 'fixed',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '45px 80px',
    backgroundColor: '#CA8456'
  },
  barometerTitle: {
    textAlign: 'center',
    color: '#fff7f7',
    fontSize: 19,
    fontWeight: 'bold',
    marginBottom: 20,

  },
  formsetRow: {
    justifyContent: 'space-around'
  },
  formsetColumn: {
    width: '25%',
    margin: 0,
    textAlign: 'center',
  },
  newspaper: {
    maxHeight: '70vh'
  },
  newspaperContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    /* align-content: center, */
    alignItems: 'center',
  },
  questionsContainer: {
    padding: 20,
    maxWidth: 800,
    margin: '0 auto'
  },
  articleTitleBorder: {
    backgroundColor: 'black',
    height: 5,
    width: '30%',
    margin: '30px 0px'
  },
  quizContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
  }, commentContainer: {
    width: '100%',
    flexDirection: 'column',
    display: 'flex',
  },
  activityText: {
    backgroundColor: 'black',
    color: 'white',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: 20,

    margin:10
  },
  dragDescription: {
    backgroundColor: '#8b0000',
    color: '#fff7f7',
    fontSize: 16,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: 20,
    margin:10
  },
})

const image_map = [
  { // Source
    x1: 160, y1: 50, x2: 410, y2: 90,
    title: 'SOURCE',
    question: 'Where is this source published? What are other (similar) sources published in this media? Who is the target audience?'
  },
  { // Title
    x1: 160, y1: 90, x2: 580, y2: 180,
    title: 'TITLE',
    question: 'What experiences (professional, life, educational, etc.) give the author credits and qualifications to wrote on this topic?'
  },
  { // Author
    x1: 160, y1: 290, x2: 580, y2: 390,
    title: 'AUTHOR',
    question: 'How does it reflect author\'s background? What are the key words?'
  },
  { // Date
    x1: 410, y1: 50, x2: 580, y2: 90,
    title: 'DATE',
    question: 'Is this a new source about the recent event(s)? Or is this a new source about the past event that has a significant meaning now?'
  },
]

const questions = [
  'Making jokes from pictures on the wall',
  'Talking loudly',
  'Getting worried and frustrated ',
  'Taking responsibility in recognizing yourself in the role of perpetrators',
  'Feeling guilty in the name of the perpetrators',
  'Staying in the group',
  'Checking the phone and texting with friends',
  'Practicing silence observation',
  'Asking questions',
  'Running through the museum collection because we don’t have enough time and we came late',
  'Learning why a place is a memorial and about the events that happened there',
  'Taking selfies',
  'Being bored',
  'Taking pictures with hashtags and posting on social media',
  'Eating in sacred places and sitting on graves',
  'Climbing on the things that I don’t know what they are',
  'Not asking question',
  'Feeling that I am in a place like any other, like bar, school hall, park.',
  'Thinking that I have the power in the future to change or not to repeat the same bad things',
  'Chatting about random stuff',
  'Keep spending time at the memorial for every price even if it causes me discomfort',
  'Feeling detached ',
  'Asking for help (a teacher, a guide, or school mates) if feeling uncomfortable',
]

class DosAndDontsQuiz extends React.Component {
  state = {
    currentQuestion: 0,
    questionState: [],
    finished: false,
  }

  componentDidMount () {
    let questionState = questions.map(() => ({ anwser: false, anwsered: false, commented: false }))
    console.log('didmount', questionState)

    this.setState({ questionState })

  }

  handleAnswer = (yes) => () => {
    let { currentQuestion, questionState, finished } = this.state
    if (finished) {
      return
    }
    questionState[currentQuestion].anwser = yes
    questionState[currentQuestion].anwsered = true

    this.setState({ questionState })
  }
  handleComment = () => {
    let { currentQuestion, questionState, finished } = this.state
    if (finished) {
      return
    }
    questionState[currentQuestion].comment = 'aadfasd'
    questionState[currentQuestion].commented = true
    currentQuestion++
    if (currentQuestion > questions.length) {
      finished = true
    }

    this.setState({ questionState, currentQuestion, finished })
  }

  render () {
    const { currentQuestion, questionState } = this.state
    const { classes } = this.props

    return <div className={classes.root}>
      <Typography variant={'h5'} className={classes.activityText}>
        How should one behave at mass atrocity memorial?
        <br/>
        Decide, if it is appropriate:
      </Typography>
      <Typography variant={'h4'} className={classes.dragDescription}>

        {questions[currentQuestion]}:
      </Typography>
      {(questionState.length > 0) ?
        <div className={classes.quizContainer}>
          <div>
            <Button
              onClick={
                this.handleAnswer(false)
              }
              variant={'outlined'}
              color={questionState[currentQuestion].anwsered && !questionState[currentQuestion].anwser ?
                'primary' : ''}
              className={classes.startButton}>
              No
            </Button>
            <Button
              color={questionState[currentQuestion].anwsered && questionState[currentQuestion].anwser ?
                'primary' : ''}
              variant={'outlined'}

              onClick={
                this.handleAnswer(true)
              } className={classes.startButton}>
              Yes
            </Button>
          </div>
          {questionState[currentQuestion].anwsered && <div className={classes.commentContainer}>
            <TextField id="standard-basic" label="COMMENT YOUR DECISION"
                       multiline={true}

            />
            <Button
              disabled={questionState[currentQuestion].commented}
              onClick={
                this.handleComment
              } color="primary" className={classes.startButton}>
              Submit
            </Button>
          </div>}
        </div> : ''
      }

    </div>
  }
}

export default withWidth()(withStyles(styles, { withTheme: true })(
  DosAndDontsQuiz
))
